/*
 * @Descripttion: 商品报备页
 * @Author: cb4786
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-27 13:24:44
 */

import { FC } from 'react'
import useFilingHooks from './hooks'
import {
  Button,
  Divider,
  Form,
  Row,
  Input,
  Col,
  DatePicker,
  Table,
  Space,
  InputNumber,
  Modal,
  Cascader,
} from 'antd'
import Style from './cooperation.module.scss'
import { LoadingOutlined, DownloadOutlined } from '@ant-design/icons'
import { formatStr } from '../../tools/util'
import TableAntd from '../../components/TableAntd'
import Search from '../../components/SearchFilter'
import PlatformSelect from '../../components/PlatformSelect'
import CustomerUnitSelect from '../../components/CustomForm/CustomerUnitSelect'
import Uploadfiles from '../../modules/uploadfiles'

// 导入文件右侧通知提醒框内容渲染
export const notificationDesRender = (list: string[]) =>
  list.map((item, index) => <div key={index}>{item}</div>)

export interface Props {
  detail?: boolean
  id?: string
}

const Cooperation: FC<Props> = (props: Props) => {
  const {
    form,
    state,
    areaOptions,
    isH5Detail,
    saveDate,
    setNewData,
    handleAdd,
    deleteTable,
    closeTab,
    selectionChange,
    setStaffModalVisible,
    handleSearchClick,
    onClickStaffRow,
    changeImportModalVisible,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    getOriginFile,
    handleFormDataChange,
  } = useFilingHooks(props)
  const {
    disabledOperate,
    dataSource,
    staffModalVisible,
    userListdataSource,
    displayTip,
    fillingSheetState,
    dataSourceLoading,
    userListdataSourceLoading,
    isImportModalVisible,
    isImportModalConfirmBtnLoading,
    uploadFilesList,
    importLoadingTip,
    platformList,
  } = state

  const listColumn = [
    {
      title: '商品编码',
      dataIndex: 'code',
      width: 200,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item
            name={'code' + index}
            style={{ margin: 0 }}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'TextNumber')
            }}
          >
            <Input
              disabled={disabledOperate || record.disablesCode}
              onChange={(e) => {
                // 过滤粘贴过来的数据可能含有的空格
                const formatedVal = formatStr(e.target.value, 'TextNumber')
                setNewData(formatedVal, index, 'code')
              }}
              suffix={
                record.loading ? (
                  <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                ) : (
                  ''
                )
              }
            />
          </Form.Item>
        )
      },
    },
    {
      title: '品牌',
      dataIndex: 'brand',
      width: 220,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'brand' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'brand')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'name' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'name')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'model' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'model')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '数量',
      dataIndex: 'num',
      width: 120,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item
            name={'num' + index}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: '请输入数量',
              },
            ]}
          >
            <InputNumber
              min={0.01}
              max={999999}
              disabled={disabledOperate}
              parser={priceFilterNoNum}
              style={{ width: '100%' }}
              onChange={(e) => {
                setNewData(e, index, 'num')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '点单价',
      dataIndex: 'price',
      render: (text: string, record: any, index: any) => {
        return (
          <Form.Item
            name={'price' + index}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: '请输入点单价',
              },
            ]}
          >
            <InputNumber
              disabled={disabledOperate}
              parser={priceFilterNoNum}
              style={{ width: '100%' }}
              onChange={(e) => {
                setNewData(e, index, 'price')
              }}
            />
          </Form.Item>
        )
      },
    },
  ]
  const userListColumns = [
    {
      key: 'name',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'parentNames',
      title: '所属公司',
      render: (text: string) => (text ? text.split(',')[1] : ''),
    },
  ]
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      selectionChange(selectedRowKeys)
    },
  }
  const priceFilterNoNum = (value: any) => {
    const reg = /^(-)*(\d+)\.(\d\d).*$/
    // eslint-disable-next-line
    return value.replace(/[^\.\d]/g, '').replace(reg, '$1$2.$3')
  }
  return (
    <div className={Style['container']} style={{ padding: '0 20px' }}>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>报备单</span>
          {fillingSheetState.state === '审核驳回' && (
            <p className={Style.approvalOpinion}>
              驳回原因：{fillingSheetState.approvalOpinion}
            </p>
          )}
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <Form form={form} onValuesChange={handleFormDataChange}>
            <Row justify="space-between">
              <Col span={5}>
                <Form.Item label="报备单号" name="filingNo">
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="报备单号"
                  name="id"
                  style={{ display: 'none' }}
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="报备数量"
                  name="num"
                  style={{ display: 'none' }}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备单状态" name="state">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备时间" name="filingTime">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备金额" name="price">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col span={5}>
                <Form.Item label="报备有效期" name="validity">
                  <Input disabled></Input>
                </Form.Item>
              </Col>
              <Col span={5}>
                {disabledOperate ? (
                  <>
                    <Form.Item noStyle name={'platform'}>
                      <Input hidden />
                    </Form.Item>
                    <Form.Item label="下单平台" name={'platformName'} required>
                      <Input disabled />
                    </Form.Item>
                  </>
                ) : (
                  <Form.Item
                    label="下单平台"
                    name="platform"
                    rules={[{ required: true, message: '请选择下单平台' }]}
                  >
                    <PlatformSelect
                      platformListData={platformList}
                      placeholder="请输入"
                      disabled={disabledOperate}
                      isH5Detail={isH5Detail}
                    />
                  </Form.Item>
                )}
              </Col>

              <Col span={5}>
                <Form.Item
                  label="预计点单日"
                  name="orderTime"
                  rules={[
                    {
                      type: 'object' as const,
                      required: true,
                      message: '请选择预点单日',
                    },
                  ]}
                >
                  <DatePicker
                    disabled={disabledOperate}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="对接销售"
                  name="dockingSalesName"
                  rules={[
                    {
                      required: true,
                      message: '请选择对接销售',
                    },
                  ]}
                >
                  <Input
                    disabled={disabledOperate}
                    readOnly
                    onClick={() => setStaffModalVisible(true)}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="对接销售id" name="dockingSalesId" noStyle>
                  <Input hidden />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between">
              {isH5Detail && (
                <Col span={5}>
                  <Form.Item name={'approvalMan'} label="最终审核人">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>
              )}
              <Col span={5}>
                {isH5Detail ? (
                  <Form.Item label="客户收货地址" name="receiveAddressName">
                    <Input disabled />
                  </Form.Item>
                ) : (
                  <Form.Item
                    label="客户收货地址"
                    name="receiveAddress"
                    rules={[
                      {
                        required: true,
                        message: '请选择客户收货地址',
                      },
                    ]}
                  >
                    <Cascader
                      options={areaOptions as any[]}
                      fieldNames={{ label: 'name', value: 'code' }}
                      placeholder="请选择客户收货地址"
                      disabled={disabledOperate}
                    />
                  </Form.Item>
                )}
              </Col>
              <Col span={5}>
                <Form.Item
                  label="客户单位"
                  name="customer"
                  rules={[{ required: true, message: '请输入客户单位' }]}
                  extra="请输入至少4个字进行搜索"
                >
                  <CustomerUnitSelect
                    disabled={disabledOperate}
                    onChange={(v, option) =>
                      form.setFieldsValue({
                        customerMdmCode: (option as any)?.mdmCode || undefined,
                        crmExists: (option as any)?.crmExists,
                      })
                    }
                    style={{ width: '400px' }}
                  />
                  {/* <Input disabled={disabledOperate} /> */}
                </Form.Item>
                <Form.Item hidden name={'customerMdmCode'}>
                  <Input />
                </Form.Item>
                <Form.Item hidden name={'crmExists'}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}></Col>
              <Col span={2}></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item label="备注" name="remark">
                  <Input.TextArea disabled={disabledOperate} allowClear />
                </Form.Item>
              </Col>
            </Row>
            <div className={Style.tableHeat}>
              <div>
                {!disabledOperate ? (
                  <Space>
                    <Button
                      size="small"
                      onClick={handleAdd}
                      disabled={importLoadingTip}
                    >
                      新增行
                    </Button>
                    <Button
                      size="small"
                      onClick={deleteTable}
                      disabled={importLoadingTip}
                    >
                      删除行
                    </Button>
                    <Button
                      size="small"
                      onClick={() => changeImportModalVisible(true)}
                      disabled={importLoadingTip}
                    >
                      导入
                    </Button>
                  </Space>
                ) : null}
              </div>
              {!displayTip && (
                <div className={Style.text}>
                  报备单存在无商品编码的商品时，报备成功概率几乎为0，请尽快补充商品编码
                </div>
              )}
            </div>
            <div
              style={{
                textAlign: 'center',
                padding: '6px 0',
                background: 'rgba(181,181,181)',
                fontSize: '16px',
              }}
            >
              报备商品明细
            </div>
            <Table
              scroll={{ y: 650 }}
              columns={listColumn}
              dataSource={dataSource}
              bordered
              rowKey="id"
              rowSelection={{ ...rowSelection }}
              pagination={false}
            />
          </Form>
        </div>
      </div>
      {!disabledOperate && (
        <div className={Style['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={closeTab}>取消</Button>
            </div>
            <Button
              onClick={saveDate}
              type="primary"
              loading={dataSourceLoading}
              disabled={importLoadingTip}
            >
              提交
            </Button>
          </Space>
        </div>
      )}
      <Modal
        title="请选择员工"
        destroyOnClose
        width={900}
        style={{ top: '25%' }}
        footer={null}
        open={staffModalVisible}
        maskClosable={false}
        onCancel={() => setStaffModalVisible(false)}
      >
        <Search
          hideScheme
          keyName="RELEVANCEBUYER"
          ScreenKey="RELEVANCEBUYER"
          fieldsData={['realName', 'mobile']}
          onSearch={handleSearchClick}
        />
        <TableAntd
          selfAdaptScroll
          loading={userListdataSourceLoading}
          dataSource={userListdataSource}
          listColumn={userListColumns}
          onRow={(record: any) => {
            return {
              onClick: () => onClickStaffRow(record), // 点击行
            }
          }}
        />
      </Modal>
      <Modal
        title="导入报备物料"
        open={isImportModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width="25%"
        style={{ top: '25%' }}
        okText="提交"
        cancelButtonProps={{
          disabled: isImportModalConfirmBtnLoading,
          onClick: () => changeImportModalVisible(false),
        }}
        okButtonProps={{
          type: 'primary',
          loading: isImportModalConfirmBtnLoading,
          onClick: cofirmImportModal,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={downloadTemplate}>
            下载导入模板 <DownloadOutlined />
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title="选择文件"
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            getOriginFile={getOriginFile}
            accept=".xls,.xlsx"
            maxCount={1}
            directlyDelete
            type="scpImportProduct"
          />
          {!uploadFilesList.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default Cooperation
/*
 * @Descripttion: 商品报备页
 * @Author: cb4786
 * @Date: 2023-08-28 17:38:13
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-27 13:24:44
 */

import { FC } from 'react'
import useFilingHooks from './hooks'
import {
  Button,
  Divider,
  Form,
  Row,
  Input,
  Col,
  DatePicker,
  Table,
  Space,
  InputNumber,
  Modal,
  Cascader,
} from 'antd'
import Style from './cooperation.module.scss'
import { LoadingOutlined, DownloadOutlined } from '@ant-design/icons'
import { formatStr } from '../../tools/util'
import TableAntd from '../../components/TableAntd'
import Search from '../../components/SearchFilter'
import PlatformSelect from '../../components/PlatformSelect'
import CustomerUnitSelect from '../../components/CustomForm/CustomerUnitSelect'
import Uploadfiles from '../../modules/uploadfiles'

// 导入文件右侧通知提醒框内容渲染
export const notificationDesRender = (list: string[]) =>
  list.map((item, index) => <div key={index}>{item}</div>)

export interface Props {
  detail?: boolean
  id?: string
}

const Cooperation: FC<Props> = (props: Props) => {
  const {
    form,
    state,
    areaOptions,
    isH5Detail,
    saveDate,
    setNewData,
    handleAdd,
    deleteTable,
    closeTab,
    selectionChange,
    setStaffModalVisible,
    handleSearchClick,
    onClickStaffRow,
    changeImportModalVisible,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    getOriginFile,
    handleFormDataChange,
  } = useFilingHooks(props)
  const {
    disabledOperate,
    dataSource,
    staffModalVisible,
    userListdataSource,
    displayTip,
    fillingSheetState,
    dataSourceLoading,
    userListdataSourceLoading,
    isImportModalVisible,
    isImportModalConfirmBtnLoading,
    uploadFilesList,
    importLoadingTip,
    platformList,
  } = state

  const listColumn = [
    {
      title: '商品编码',
      dataIndex: 'code',
      width: 200,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item
            name={'code' + index}
            style={{ margin: 0 }}
            getValueFromEvent={(e) => {
              return formatStr(e.target.value, 'TextNumber')
            }}
          >
            <Input
              disabled={disabledOperate || record.disablesCode}
              onChange={(e) => {
                // 过滤粘贴过来的数据可能含有的空格
                const formatedVal = formatStr(e.target.value, 'TextNumber')
                setNewData(formatedVal, index, 'code')
              }}
              suffix={
                record.loading ? (
                  <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                ) : (
                  ''
                )
              }
            />
          </Form.Item>
        )
      },
    },
    {
      title: '品牌',
      dataIndex: 'brand',
      width: 220,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'brand' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'brand')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'name' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'name')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item name={'model' + index} style={{ margin: 0 }}>
            <Input
              disabled={disabledOperate || record.disables}
              onChange={(e) => {
                setNewData(e.target.value, index, 'model')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '数量',
      dataIndex: 'num',
      width: 120,
      render: (text: string, record: any, index: number) => {
        return (
          <Form.Item
            name={'num' + index}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: '请输入数量',
              },
            ]}
          >
            <InputNumber
              min={0.01}
              max={999999}
              disabled={disabledOperate}
              parser={priceFilterNoNum}
              style={{ width: '100%' }}
              onChange={(e) => {
                setNewData(e, index, 'num')
              }}
            />
          </Form.Item>
        )
      },
    },
    {
      title: '点单价',
      dataIndex: 'price',
      render: (text: string, record: any, index: any) => {
        return (
          <Form.Item
            name={'price' + index}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: '请输入点单价',
              },
            ]}
          >
            <InputNumber
              disabled={disabledOperate}
              parser={priceFilterNoNum}
              style={{ width: '100%' }}
              onChange={(e) => {
                setNewData(e, index, 'price')
              }}
            />
          </Form.Item>
        )
      },
    },
  ]
  const userListColumns = [
    {
      key: 'name',
      title: '姓名',
    },
    {
      key: 'mobile',
      title: '手机号码',
    },
    {
      key: 'parentNames',
      title: '所属公司',
      render: (text: string) => (text ? text.split(',')[1] : ''),
    },
  ]
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      selectionChange(selectedRowKeys)
    },
  }
  const priceFilterNoNum = (value: any) => {
    const reg = /^(-)*(\d+)\.(\d\d).*$/
    // eslint-disable-next-line
    return value.replace(/[^\.\d]/g, '').replace(reg, '$1$2.$3')
  }
  return (
    <div className={Style['container']} style={{ padding: '0 20px' }}>
      <div className={Style.box}>
        <div className={Style.boxtitle}>
          <span>报备单</span>
          {fillingSheetState.state === '审核驳回' && (
            <p className={Style.approvalOpinion}>
              驳回原因：{fillingSheetState.approvalOpinion}
            </p>
          )}
        </div>
        <Divider style={{ marginTop: 0 }} />
        <div style={{ padding: '0 20px' }}>
          <Form form={form} onValuesChange={handleFormDataChange}>
            <Row justify="space-between">
              <Col span={5}>
                <Form.Item label="报备单号" name="filingNo">
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="报备单号"
                  name="id"
                  style={{ display: 'none' }}
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="报备数量"
                  name="num"
                  style={{ display: 'none' }}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备单状态" name="state">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备时间" name="filingTime">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="报备金额" name="price">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between">
              <Col span={5}>
                <Form.Item label="报备有效期" name="validity">
                  <Input disabled></Input>
                </Form.Item>
              </Col>
              <Col span={5}>
                {disabledOperate ? (
                  <>
                    <Form.Item noStyle name={'platform'}>
                      <Input hidden />
                    </Form.Item>
                    <Form.Item label="下单平台" name={'platformName'} required>
                      <Input disabled />
                    </Form.Item>
                  </>
                ) : (
                  <Form.Item
                    label="下单平台"
                    name="platform"
                    rules={[{ required: true, message: '请选择下单平台' }]}
                  >
                    <PlatformSelect
                      platformListData={platformList}
                      placeholder="请输入"
                      disabled={disabledOperate}
                      isH5Detail={isH5Detail}
                    />
                  </Form.Item>
                )}
              </Col>

              <Col span={5}>
                <Form.Item
                  label="预计点单日"
                  name="orderTime"
                  rules={[
                    {
                      type: 'object' as const,
                      required: true,
                      message: '请选择预点单日',
                    },
                  ]}
                >
                  <DatePicker
                    disabled={disabledOperate}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="对接销售"
                  name="dockingSalesName"
                  rules={[
                    {
                      required: true,
                      message: '请选择对接销售',
                    },
                  ]}
                >
                  <Input
                    disabled={disabledOperate}
                    readOnly
                    onClick={() => setStaffModalVisible(true)}
                  />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label="对接销售id" name="dockingSalesId" noStyle>
                  <Input hidden />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between">
              {isH5Detail && (
                <Col span={5}>
                  <Form.Item name={'approvalMan'} label="最终审核人">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>
              )}
              <Col span={5}>
                {isH5Detail ? (
                  <Form.Item label="客户收货地址" name="receiveAddressName">
                    <Input disabled />
                  </Form.Item>
                ) : (
                  <Form.Item
                    label="客户收货地址"
                    name="receiveAddress"
                    rules={[
                      {
                        required: true,
                        message: '请选择客户收货地址',
                      },
                    ]}
                  >
                    <Cascader
                      options={areaOptions as any[]}
                      fieldNames={{ label: 'name', value: 'code' }}
                      placeholder="请选择客户收货地址"
                      disabled={disabledOperate}
                    />
                  </Form.Item>
                )}
              </Col>
              <Col span={5}>
                <Form.Item
                  label="客户单位"
                  name="customer"
                  rules={[{ required: true, message: '请输入客户单位' }]}
                  extra="请输入至少4个字进行搜索"
                >
                  <CustomerUnitSelect
                    disabled={disabledOperate}
                    onChange={(v, option) =>
                      form.setFieldsValue({
                        customerMdmCode: (option as any)?.mdmCode || undefined,
                        crmExists: (option as any)?.crmExists,
                      })
                    }
                    style={{ width: '400px' }}
                  />
                  {/* <Input disabled={disabledOperate} /> */}
                </Form.Item>
                <Form.Item hidden name={'customerMdmCode'}>
                  <Input />
                </Form.Item>
                <Form.Item hidden name={'crmExists'}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={5}></Col>
              <Col span={2}></Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item label="备注" name="remark">
                  <Input.TextArea disabled={disabledOperate} allowClear />
                </Form.Item>
              </Col>
            </Row>
            <div className={Style.tableHeat}>
              <div>
                {!disabledOperate ? (
                  <Space>
                    <Button
                      size="small"
                      onClick={handleAdd}
                      disabled={importLoadingTip}
                    >
                      新增行
                    </Button>
                    <Button
                      size="small"
                      onClick={deleteTable}
                      disabled={importLoadingTip}
                    >
                      删除行
                    </Button>
                    <Button
                      size="small"
                      onClick={() => changeImportModalVisible(true)}
                      disabled={importLoadingTip}
                    >
                      导入
                    </Button>
                  </Space>
                ) : null}
              </div>
              {!displayTip && (
                <div className={Style.text}>
                  报备单存在无商品编码的商品时，报备成功概率几乎为0，请尽快补充商品编码
                </div>
              )}
            </div>
            <div
              style={{
                textAlign: 'center',
                padding: '6px 0',
                background: 'rgba(181,181,181)',
                fontSize: '16px',
              }}
            >
              报备商品明细
            </div>
            <Table
              scroll={{ y: 650 }}
              columns={listColumn}
              dataSource={dataSource}
              bordered
              rowKey="id"
              rowSelection={{ ...rowSelection }}
              pagination={false}
            />
          </Form>
        </div>
      </div>
      {!disabledOperate && (
        <div className={Style['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={closeTab}>取消</Button>
            </div>
            <Button
              onClick={saveDate}
              type="primary"
              loading={dataSourceLoading}
              disabled={importLoadingTip}
            >
              提交
            </Button>
          </Space>
        </div>
      )}
      <Modal
        title="请选择员工"
        destroyOnClose
        width={900}
        style={{ top: '25%' }}
        footer={null}
        open={staffModalVisible}
        maskClosable={false}
        onCancel={() => setStaffModalVisible(false)}
      >
        <Search
          hideScheme
          keyName="RELEVANCEBUYER"
          ScreenKey="RELEVANCEBUYER"
          fieldsData={['realName', 'mobile']}
          onSearch={handleSearchClick}
        />
        <TableAntd
          selfAdaptScroll
          loading={userListdataSourceLoading}
          dataSource={userListdataSource}
          listColumn={userListColumns}
          onRow={(record: any) => {
            return {
              onClick: () => onClickStaffRow(record), // 点击行
            }
          }}
        />
      </Modal>
      <Modal
        title="导入报备物料"
        open={isImportModalVisible}
        keyboard={false}
        maskClosable={false}
        closable={false}
        width="25%"
        style={{ top: '25%' }}
        okText="提交"
        cancelButtonProps={{
          disabled: isImportModalConfirmBtnLoading,
          onClick: () => changeImportModalVisible(false),
        }}
        okButtonProps={{
          type: 'primary',
          loading: isImportModalConfirmBtnLoading,
          onClick: cofirmImportModal,
        }}
      >
        <div style={{ userSelect: 'none', marginBottom: 8 }}>
          1、
          <a onClick={downloadTemplate}>
            下载导入模板 <DownloadOutlined />
          </a>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '12px' }}> 2、上传导入文件</div>
          <Uploadfiles
            title="选择文件"
            dataSource={uploadFilesList}
            onChange={handleUploadfilesChange}
            getOriginFile={getOriginFile}
            accept=".xls,.xlsx"
            maxCount={1}
            directlyDelete
            type="scpImportProduct"
          />
          {!uploadFilesList.length && (
            <div style={{ color: '#5b6b73', marginLeft: '8px' }}>
              未选择任何文件
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default Cooperation
